export function getDepartmentTitle(departmentId = null, departments) {
  return departmentId
    ? departments.find((department) => department.id === departmentId).title
    : "All Departments";
}
